import Styled from 'styled-components';

interface CommentsMsgProps {
  onMobile?: boolean;
}

const CommentsMsgHeaderStyle = Styled.div<CommentsMsgProps>`
display: flex;
flex-direction: row;
width:100%;
justify-content: ${({ onMobile }) => (onMobile ? 'center' : 'flex-start')};
align-items: center;
padding: 20px 16px;
position:relative;
background: #F4F4F4;
border-radius: 8px;
font-size: 14px;
font-weight: 400;
color: #404040;
> svg {
    margin-top: 16px;
  }
`;
const CommentsMsgStyle = Styled.div<CommentsMsgProps>`
display: flex;
flex-direction: row;
width:inherit;
height:60px;
justify-content: ${({ onMobile }) => (onMobile ? 'center' : 'flex-start')};
align-items: center;
padding: 20px 16px;
background: #F4F4F4;
border-radius: 8px;
font-size: 14px;
font-weight: 400;
color: #404040;
`;

export { CommentsMsgHeaderStyle, CommentsMsgStyle };
